import { RESPONSIVE_BREAKPOINTS } from '@sirius/responsive';

export enum DeviceType {
    MOBILE,
    DESKTOP,
}

export enum DeviceSize {
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
    XXL = 'xxl',
}

export abstract class DeviceData {
    public static breakpoints: Record<DeviceSize, number> = {
        [DeviceSize.SM]: RESPONSIVE_BREAKPOINTS.sm,
        [DeviceSize.MD]: RESPONSIVE_BREAKPOINTS.md,
        [DeviceSize.LG]: RESPONSIVE_BREAKPOINTS.lg,
        [DeviceSize.XL]: RESPONSIVE_BREAKPOINTS.xl,
        [DeviceSize.XXL]: RESPONSIVE_BREAKPOINTS.xxl,
    };
}
